export default function (props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M31.3926 27.6286V30.9885C31.3926 31.2117 31.3506 31.4266 31.2677 31.6319C31.1848 31.8371 31.0658 32.0198 30.9117 32.1773C30.7576 32.3349 30.5802 32.4554 30.3783 32.5414C30.1763 32.6261 29.9674 32.6691 29.7491 32.6691H18.2484C18.0302 32.6691 17.8212 32.6261 17.6193 32.5414C17.4174 32.4554 17.24 32.3349 17.0859 32.1773C16.9318 32.0198 16.8127 31.8371 16.7299 31.6319C16.647 31.4266 16.605 31.2117 16.605 30.9885V27.6286"
                stroke="#83868A"
                strokeWidth="2.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M19.8936 23.4293L24.001 27.6295L28.1085 23.4293" stroke="#83868A" strokeWidth="2.14286" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24 27.6252V17.5443" stroke="#83868A" strokeWidth="2.14286" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M29 6H12C10.8954 6 10 6.89543 10 8V40C10 41.1046 10.8954 42 12 42H36C37.1046 42 38 41.1046 38 40V16M29 6L38 16M29 6V14C29 15.1046 29.8954 16 31 16H38"
                stroke="#83868A"
                strokeWidth="2.14286"
            />
        </svg>
    );
}
